import Seo from "../Seo/Seo";
import "./mentionsLegales.css";

const legalSections = [
  {
    id: "editeur",
    title: "Editeur du site",
    content: (
      <>
        <p>
          Le present site est edite par <strong>PROVENCE PAIE</strong>, SAS,
          societe par actions simplifiee, immatriculee sous le numero SIREN{" "}
          <strong>987 619 319</strong>.
        </p>
        <ul className="legal-list" aria-label="Coordonnees de l'editeur du site">
          <li>
            Denomination sociale : <strong>PROVENCE PAIE</strong>
          </li>
          <li>
            Forme juridique :{" "}
            <strong>SAS, societe par actions simplifiee</strong>
          </li>
          <li>
            SIREN : <strong>987 619 319</strong>
          </li>
          <li>
            SIRET (siege) : <strong>987 619 319 00013</strong>
          </li>
          <li>
            TVA intracommunautaire : <strong>FR50987619319</strong>
          </li>
          <li>
            Contact e-mail :{" "}
            <span className="legal-placeholder">
              [A completer : adresse e-mail de contact]
            </span>
          </li>
          <li>
            Telephone :{" "}
            <span className="legal-placeholder">
              [A completer : numero de telephone de contact]
            </span>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "societe",
    title: "Informations sur la societe",
    content: (
      <>
        <p>
          PROVENCE PAIE est immatriculee au Registre du commerce et des
          societes et au Registre national des entreprises selon les
          informations communiquees ci-dessous.
        </p>
        <ul className="legal-list" aria-label="Informations legales de la societe">
          <li>
            Inscription au RCS :{" "}
            <strong>INSCRIT (au greffe de SALON-DE-PROVENCE, le 20/03/2024)</strong>
          </li>
          <li>
            Numero RCS : <strong>987 619 319 R.C.S. Salon-de-Provence</strong>
          </li>
          <li>
            Inscription au RNE : <strong>INSCRIT</strong>
          </li>
          <li>
            Capital social : <strong>1 000,00 EUR</strong>
          </li>
          <li>
            Date de creation de l'etablissement : <strong>01/03/2024</strong>
          </li>
          <li>
            Cloture de l'exercice comptable : <strong>31/12/2026</strong>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "activite",
    title: "Activite de l'entreprise",
    content: (
      <>
        <p>
          L'activite principale declaree de PROVENCE PAIE est la suivante :
        </p>
        <p className="legal-highlight">
          Le conseil et l'assistance operationnelle apportes aux entreprises et
          autres organisations en matiere de traitement de la paie. La
          realisation de solutions d'externalisation de la paie, la gestion des
          bulletins de salaire, des evenements de paie courants (entree,
          sortie, maladie) et des declarations sociales mensuelles,
          trimestrielles et annuelles. La dispense de prestations connexes pour
          faciliter la gestion de ressources humaines. L'assistance a la
          gestion sociale.
        </p>
        <ul className="legal-list" aria-label="Informations sur l'activite de l'entreprise">
          <li>
            Code NAF / APE : <strong>70.22Z</strong>
          </li>
          <li>
            Libelle APE :{" "}
            <strong>Conseil pour les affaires et autres conseils de gestion</strong>
          </li>
          <li>
            Domaine d'activite :{" "}
            <strong>Activites des sieges sociaux ; conseil de gestion</strong>
          </li>
          <li>
            Forme d'exercice : <strong>Artisanale non reglementee</strong>
          </li>
          <li>
            Convention collective :{" "}
            <strong>
              Bureaux d'etudes techniques, des cabinets d'ingenieurs-conseils et
              des societes de conseils - IDCC 1486
            </strong>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "siege",
    title: "Siege social",
    content: (
      <>
        <p>
          Le siege social de PROVENCE PAIE est situe a l'adresse suivante :
        </p>
        <address className="legal-address">
          355 Boulevard Ledru Rollin
          <br />
          13300 Salon-de-Provence
        </address>
      </>
    ),
  },
  {
    id: "publication",
    title: "Direction de la publication",
    content: (
      <>
        <p>
          Directeur ou directrice de la publication :
          {" "}
          <span className="legal-placeholder">
            [A completer : nom de la direction de la publication]
          </span>
        </p>
        <p className="legal-note">
          Les dirigeants declares de la societe sont : President{" "}
          <strong>Naji Moslim</strong> et Directeur general{" "}
          <strong>Bari Bouazza</strong>.
        </p>
      </>
    ),
  },
  {
    id: "propriete-intellectuelle",
    title: "Propriete intellectuelle",
    content: (
      <>
        <p>
          L'ensemble des contenus presents sur ce site, notamment les textes,
          elements graphiques, photographies, visuels, logos, icones, videos,
          documents telechargeables et, plus generalement, tout element
          accessible sur le site, est protege par les dispositions du Code de
          la propriete intellectuelle, sauf mention contraire expresse.
        </p>
        <p>
          Toute reproduction, representation, adaptation, diffusion ou
          exploitation, totale ou partielle, de tout contenu du site, par
          quelque procede que ce soit, sans autorisation prealable ecrite du
          titulaire des droits, est interdite, sauf dans les cas autorises par
          la loi.
        </p>
      </>
    ),
  },
  {
    id: "responsabilite",
    title: "Responsabilite",
    content: (
      <>
        <p>
          PROVENCE PAIE s'efforce d'assurer l'exactitude et la mise a jour des
          informations diffusees sur le site. Toutefois, l'editeur ne peut
          garantir l'exhaustivite, l'absence d'erreur ou l'actualisation
          permanente de l'ensemble des contenus.
        </p>
        <p>
          L'utilisateur reconnait utiliser les informations disponibles sur le
          site sous sa responsabilite exclusive. PROVENCE PAIE ne saurait etre
          tenue responsable des dommages directs ou indirects lies a l'acces au
          site, a son utilisation, a une indisponibilite temporaire ou a la
          presence de contenus externes accessibles via des liens hypertextes.
        </p>
      </>
    ),
  },
  {
    id: "donnees-personnelles",
    title: "Donnees personnelles",
    content: (
      <>
        <p>
          Les donnees personnelles susceptibles d'etre collectees via le site
          sont traitees dans le cadre strict des finalites liees a la gestion
          des demandes, des echanges avec les utilisateurs et, le cas echeant,
          au fonctionnement technique du site.
        </p>
        <p>
          Les informations demandees via les formulaires ou outils de contact
          doivent rester adequates, pertinentes et limitees a ce qui est
          necessaire au traitement de la demande. Les droits d'acces, de
          rectification, d'effacement, de limitation ou d'opposition peuvent
          etre exerces aupres de :
          {" "}
          <span className="legal-placeholder">
            [A completer : contact RGPD ou adresse e-mail dediee]
          </span>
          .
        </p>
        <p className="legal-note">
          En l'absence d'informations completes sur l'organisation interne du
          traitement, cette section devra etre precisee si des traitements
          supplementaires, outils tiers ou traceurs avances sont utilises.
        </p>
      </>
    ),
  },
  {
    id: "cookies",
    title: "Cookies",
    content: (
      <>
        <p>
          Le site peut utiliser des cookies ou autres traceurs strictement
          necessaires a son fonctionnement, a la mesure d'audience ou a
          l'amelioration de l'experience utilisateur, sous reserve de la
          configuration effectivement mise en place.
        </p>
        <p>
          Lorsqu'une collecte de consentement est requise, celle-ci doit etre
          mise en oeuvre avant tout depot de cookies non essentiels. L'utilisateur
          peut egalement configurer son navigateur afin de limiter ou supprimer
          les cookies, sous reserve que cela puisse affecter certaines
          fonctionnalites du site.
        </p>
      </>
    ),
  },
  {
    id: "hebergement",
    title: "Hebergement du site",
    content: (
      <>
        <p>
          Hebergeur du site :
          {" "}
          <a href="https://www.hostinger.com/" target="_blank" rel="noreferrer">
            Hostinger
          </a>
        </p>
      </>
    ),
  },
  {
    id: "conception",
    title: "Conception et developpement du site",
    content: (
      <>
        <p>
          Le site web a ete concu par l'agence{" "}
          <a
            href="https://boostaura.fr"
            target="_blank"
            rel="noreferrer"
          >
            AURABOOST
          </a>
          .
        </p>
        <p>
          URL de l'agence :{" "}
          <a
            href="https://boostaura.fr"
            target="_blank"
            rel="noreferrer"
          >
            https://boostaura.fr
          </a>
        </p>
      </>
    ),
  },
];

export default function MentionsLegales() {
  return (
    <>
      <Seo
        title="Mentions legales | PROVENCE PAIE"
        description="Consultez les mentions legales de PROVENCE PAIE : informations societaires, activite, propriete intellectuelle, responsabilite, donnees personnelles, cookies et hebergement."
        pathname="/mentions-legales"
        keywords="mentions legales Provence Paie, informations legales, editeur du site, hebergement, donnees personnelles, cookies"
      />

      <section className="legal-hero">
        <div className="legal-shell">
          <p className="legal-kicker">Information juridique</p>
          <h1>Mentions legales</h1>
          <p className="legal-intro">
            Cette page presente les informations legales et editoriales relatives
            au site de PROVENCE PAIE. 
          </p>
          <br />
          <br />
        </div>
      </section>

      <section className="legal-page">
        <div className="legal-shell legal-grid">
          <aside className="legal-summary" aria-label="Sommaire des sections">
            <p className="legal-summary-title">Sommaire</p>
            <nav>
              <ul className="legal-summary-list">
                {legalSections.map((section) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>{section.title}</a>
                  </li>
                ))}
              </ul>
            </nav>
          </aside>

          <div className="legal-content">
            {legalSections.map((section) => (
              <article key={section.id} id={section.id} className="legal-card">
                <h2>{section.title}</h2>
                {section.content}
              </article>
            ))}

            <article className="legal-card">
              <h2>Informations complementaires</h2>
              <ul className="legal-list" aria-label="Informations complementaires">
                <li>
                  Annonce de creation publiee le <strong>22/03/2024</strong>
                </li>
                <li>
                  Depot des comptes publie le <strong>27/11/2025</strong>
                </li>
                <li>
                  Mention relative aux comptes annuels :{" "}
                  <strong>
                    declaration de confidentialite en application du premier
                    alinea de l'article L. 232-25
                  </strong>
                </li>
                
              </ul>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}
